import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './ConnectedVehicle.module.scss';
import '../../css/themes.scss';
import VehicleInformation from 'src/components/ConnectedVehicle/VehicleInformation/containers/VehicleInformation';
import PrivacyInformation from 'src/components/ConnectedVehicle/PrivacyInformation/containers/PrivacyInformation';
import OdometerInformation from 'src/components/ConnectedVehicle/OdometerInformation/containers/OdometerInformation';
import BatteryInformation from 'src/components/ConnectedVehicle/BatteryInformation/containers/BatteryInformation';
import OilInformation from 'src/components/ConnectedVehicle/OilInformation/containers/OilInformation';
import FuelInformation from 'src/components/ConnectedVehicle/FuelInformation/containers/FuelInformation';
import TireInformation from 'src/components/ConnectedVehicle/TireInformation/containers/TireInformation';
import RemoteStartInformation from 'src/components/ConnectedVehicle/RemoteStartInformation/containers/RemoteStartInformation';
import VisitInformation from 'src/components/ConnectedVehicle/VisitInformation/containers/VisitInformation';
import BuildData from 'src/components/ConnectedVehicle/BuildData/containers/BuildData';
import CVLog from 'src/components/ConnectedVehicle/CVLog/containers/CVLog';
import CVSettings from 'src/components/ConnectedVehicle/CVSettings/containers/CVSettings';
import MfgInquiry from 'src/components/ConnectedVehicle/MfgInquiry/containers/MfgInquiry';
import GeoLocation from 'src/components/ConnectedVehicle/GeoLocation/containers/GeoLocation';
import EvHybridInformation from 'src/components/ConnectedVehicle/EvHybridInformation/containers/EvHybridInformation';
import ServiceHistory from 'src/components/ConnectedVehicle/ServiceHistory/containers/ServiceHistory';
import Contracts from 'src/components/ConnectedVehicle/Contracts/containers/Contracts';
import DTCPanel from 'src/components/ConnectedVehicle/DTCPanel/containers/DTCPanel';
import CampaignPanel from 'src/components/ConnectedVehicle/CampaignPanel/containers/CampaignPanel';
import RecommendedPanel from './RecommendedPanel/containers/RecommendedPanel';
import { ConnectedVehicleRec, CAMPAIGN, CheckedCAMPAIGN, CheckedDTC, CheckedRECOMMENDED, ImportedDTC, ImportedRECOMMENDED, ImportedCAMPAIGN, DTC, RECOMMENDED, COMM } from 'src/models';
import { Checkbox, Link, LoadingProgress, ScrollBar, Dialog, SelectList } from '@framework-controls/core';
import { strings } from 'src/localization';
import { IconPrint, IconDropDown, IconDropDownReverse, IconRemove, IconRestore, IconSortAscending, IconSortDescending } from 'src/content/icons';
import { IDropDownItem } from 'Framework';
import IconClientCare from 'src/content/icons/ClientCare.svg';
import IconGasPump from 'src/content/icons/GasPump.svg';
import IconOdometer from 'src/content/icons/Odometer.svg';
import IconBattery from 'src/content/icons/Battery.svg';
import IconEngine from 'src/content/icons/Engine.svg';
import IconFuelDrop from 'src/content/icons/FuelDrop.svg';
import IconTire from 'src/content/icons/Tire.svg';
import IconError from 'src/content/icons/Error.svg';
import IconSecurity from 'src/content/icons/Security.svg';
import IconAlerts from 'src/content/icons/Alerts.svg';
import IconKeys from 'src/content/icons/Keys.svg';
import IconAirFilter from 'src/content/icons/AirFilter.svg';
import CommunicationsPanel from './CommunicationsPanel/containers/CommunicationsPanel';
import PastRecalls from './PastRecalls/containers/PastRecalls';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    checkedDtc: CheckedDTC[];
    importedDtc: ImportedDTC[];
    checkedRecommended: CheckedRECOMMENDED[];
    importedRecommended: ImportedRECOMMENDED[];
    checkedCampaign: CheckedCAMPAIGN[];
    importedCampaign: ImportedCAMPAIGN[];
    mode: string;
    docType: string;
    rcardAvailFlag: string;
    getConnectedVehicle: () => void;
    clearConnectedVehicle: () => void;
    reloadConnectedVehicle: () => void;
    printConnectedVehicle: (filter: string) => void;
    invokeConnectedVehicle: (tlmId) => void;
    toggleAllDtc: () => void;
    toggleAllCampaign: () => void;
    toggleAllRecommended: () => void;
    importDtc: () => void;
    importRecommended: () => void;
    importCampaign: () => void;
    importTirePressure: (leftFront, rightFront, leftRear, rightRear, spare, oil) => void;
}

const ConnectedVehicle = (props: IProps) => {
    const [msgOpenFlag, setMsgOpenFlag] = useState<boolean>(false);
    const [msgBoxMsg, setMsgBoxMsg] = useState('');
    const [loadingCV, setLoadingCV] = useState(false);
    const [invokingCV, setInvokingCV] = useState(false);
    const [reloadingCV, setReloadingCV] = useState(false);
    const [statusOpen, setStatusOpen] = useState(true);
    const [maintOpen, setMaintOpen] = useState(true);
    const [commOpen, setCommOpen] = useState(true);
    const [dtcOpen, setDtcOpen] = useState(true);
    const [recomOpen, setRecomOpen] = useState(true);
    const [campaignOpen, setCampaignOpen] = useState(true);
    const [lfChecked, setLfChecked] = useState(false);
    const [rfChecked, setRfChecked] = useState(false);
    const [lrChecked, setLrChecked] = useState(false);
    const [rrChecked, setRrChecked] = useState(false);
    const [spareChecked, setSpareChecked] = useState(false);
    const [oilChecked, setOilChecked] = useState(false);
    const [lfImported, setLfImported] = useState(false);
    const [rfImported, setRfImported] = useState(false);
    const [lrImported, setLrImported] = useState(false);
    const [rrImported, setRrImported] = useState(false);
    const [spareImported, setSpareImported] = useState(false);
    const [oilImported, setOilImported] = useState(false);
    const [dtcSortReversed, setDtcSortReversed] = useState(false);
    const [sortIconDtcColumn, setSortIconDtcColumn] = useState('none');
    const [recomSortReversed, setRecomSortReversed] = useState(false);
    const [sortIconRecomColumn, setSortIconRecomColumn] = useState('none');
    const [campSortReversed, setCampSortReversed] = useState(false);
    const [sortIconCampColumn, setSortIconCampColumn] = useState('none');
    const [commSortReversed, setCommSortReversed] = useState(false);
    const [sortIconCommColumn, setSortIconCommColumn] = useState('none');
    const [initialLoadPerformed, setInitialLoadPerformed] = useState(false);
    const [useTlmId, setUseTlmId] = useState('');

    const CloseMsgBox = useCallback(() => {
        setMsgOpenFlag(false);
    }, []);

    const printCV = useCallback(() => {
        props.printConnectedVehicle('A');
    }, [props.printConnectedVehicle]);

    const invokeCV = useCallback((tlmId: string) => {
        setInvokingCV(true);
        setUseTlmId(tlmId);
        props.clearConnectedVehicle();
    }, [props.clearConnectedVehicle]);

    const toggleStatus = useCallback(() => {
        setStatusOpen(!statusOpen);
    }, [statusOpen]);

    const toggleMaint = useCallback(() => {
        setMaintOpen(!maintOpen);
    }, [maintOpen]);

    const toggleComm = useCallback(() => {
        setCommOpen(!commOpen);
    }, [commOpen]);

    const toggleDtcArea = useCallback(() => {
        setDtcOpen(!dtcOpen);
    }, [dtcOpen]);

    const toggleAllDtc = useCallback(() => {
        props.toggleAllDtc();
    }, [props.toggleAllDtc]);

    const importDtc = useCallback(() => {
        props.importDtc();
    }, [props.importDtc]);

    const scrollDtc = useCallback(() => {
        const dtcId = document.getElementById('dtcAreaDiv');
        if (dtcId) {
            dtcId.scrollIntoView(true);
            if (!dtcOpen) {
                setDtcOpen(true);
            }
        }
    }, [dtcOpen]);

    const toggleRecom = useCallback(() => {
        setRecomOpen(!recomOpen);
    }, [recomOpen]);

    const importRecommended = useCallback(() => {
        props.importRecommended();
    }, [props.importRecommended]);

    const toggleAllRecommended = useCallback(() => {
        props.toggleAllRecommended();
    }, [props.toggleAllRecommended]);

    const toggleCampaign = useCallback(() => {
        setCampaignOpen(!campaignOpen);
    }, [campaignOpen]);

    const toggleAllCampaign = useCallback(() => {
        props.toggleAllCampaign();
    }, [props.toggleAllCampaign]);

    const importCampaign = useCallback(() => {
        props.importCampaign();
    }, [props.importCampaign]);

    const toggleLf = useCallback(() => {
        setLfChecked(!lfChecked);
    }, [lfChecked]);

    const toggleRf = useCallback(() => {
        setRfChecked(!rfChecked);
    }, [rfChecked]);

    const toggleLr = useCallback(() => {
        setLrChecked(!lrChecked);
    }, [lrChecked]);

    const toggleRr = useCallback(() => {
        setRrChecked(!rrChecked);
    }, [rrChecked]);

    const toggleSpare = useCallback(() => {
        setSpareChecked(!spareChecked);
    }, [spareChecked]);

    const toggleOil = useCallback(() => {
        setOilChecked(!oilChecked);
    }, [oilChecked]);

    const [dateFilter, setDateFilter] = useState('current');
    const applyDateFilter = useCallback((id: string, value: string) => {
        setDateFilter(value);
    }, []);

    const importTirePressure = useCallback(() => {
        if (props.mode !== 'P') {
            if (props.rcardAvailFlag === 'Y') {
                props.importTirePressure(lfChecked, rfChecked, lrChecked, rrChecked, spareChecked, oilChecked);
                if (lfChecked) {
                    setLfChecked(false);
                    setLfImported(true);
                }
                if (rfChecked) {
                    setRfChecked(false);
                    setRfImported(true);
                }
                if (lrChecked) {
                    setLrChecked(false);
                    setLrImported(true);
                }
                if (rrChecked) {
                    setRrChecked(false);
                    setRrImported(true);
                }
                if (spareChecked) {
                    setSpareChecked(false);
                    setSpareImported(true);
                }
                if (oilChecked) {
                    setOilChecked(false);
                    setOilImported(true);
                }

                return;
            }
            if (!props.rcardAvailFlag) {
                setMsgBoxMsg(strings.NoReportCard);
                setMsgOpenFlag(true);

                return;
            }
            if (props.rcardAvailFlag === 'C') {
                setMsgBoxMsg(strings.ReportCardComplete);
                setMsgOpenFlag(true);

                return;
            }
        }
    }, [props.mode, props.importTirePressure, lfChecked, rfChecked, lrChecked, rrChecked, spareChecked, oilChecked, props.rcardAvailFlag]);

    const checkAll = useCallback(() => {
        if (props.mode !== 'P') {
            setLfChecked(true);
            setRfChecked(true);
            setLrChecked(true);
            setRrChecked(true);
            setOilChecked(true);
            setSpareChecked(true);
        }
    }, [props.mode]);

    const reverseDtcSort = useCallback(() => {
        setDtcSortReversed(!dtcSortReversed);
    }, [dtcSortReversed]);

    const reverseRecomSort = useCallback(() => {
        setRecomSortReversed(!recomSortReversed);
    }, [recomSortReversed]);

    const reverseCampSort = useCallback(() => {
        setCampSortReversed(!campSortReversed);
    }, [campSortReversed]);

    const reverseCommSort = useCallback(() => {
        setCommSortReversed(!commSortReversed);
    }, [commSortReversed]);

    const moveFocusToDtc = useCallback((column: string) => {
        if ((column === 'code') && (sortIconDtcColumn !== 'code')) {
            setDtcSortReversed(false);
        }
        if ((column === 'desc') && (sortIconDtcColumn !== 'desc')) {
            setDtcSortReversed(false);
        }
        if ((column === 'emission') && (sortIconDtcColumn !== 'emission')) {
            setDtcSortReversed(false);
        }
        if ((column === 'ecmecu') && (sortIconDtcColumn !== 'ecmecu')) {
            setDtcSortReversed(false);
        }
        if ((column === 'symptom') && (sortIconDtcColumn !== 'symptom')) {
            setDtcSortReversed(false);
        }
        if ((column === 'status') && (sortIconDtcColumn !== 'status')) {
            setDtcSortReversed(false);
        }
        setSortIconDtcColumn(column);
    }, [sortIconDtcColumn]);

    const moveFocusToRecom = useCallback((column: string) => {
        if ((column === 'id') && (sortIconRecomColumn !== 'id')) {
            setRecomSortReversed(false);
        }
        if ((column === 'desc') && (sortIconRecomColumn !== 'desc')) {
            setRecomSortReversed(false);
        }
        if ((column === 'source') && (sortIconRecomColumn !== 'source')) {
            setRecomSortReversed(false);
        }
        if ((column === 'status') && (sortIconRecomColumn !== 'status')) {
            setRecomSortReversed(false);
        }
        if ((column === 'duedate') && (sortIconRecomColumn !== 'duedate')) {
            setRecomSortReversed(false);
        }
        if ((column === 'distance') && (sortIconRecomColumn !== 'distance')) {
            setRecomSortReversed(false);
        }
        if ((column === 'opcode') && (sortIconRecomColumn !== 'opcode')) {
            setRecomSortReversed(false);
        }
        setSortIconRecomColumn(column);
    }, [sortIconRecomColumn]);

    const moveFocusToCamp = useCallback((column: string) => {
        if ((column === 'desc') && (sortIconCampColumn !== 'desc')) {
            setRecomSortReversed(false);
        }
        if ((column === 'code') && (sortIconCampColumn !== 'code')) {
            setRecomSortReversed(false);
        }
        if ((column === 'remedy') && (sortIconCampColumn !== 'remedy')) {
            setRecomSortReversed(false);
        }
        if ((column === 'stopsale') && (sortIconCampColumn !== 'stopsale')) {
            setRecomSortReversed(false);
        }
        if ((column === 'startdate') && (sortIconCampColumn !== 'startdate')) {
            setRecomSortReversed(false);
        }
        if ((column === 'recallbulletin') && (sortIconCampColumn !== 'recallbulletin')) {
            setRecomSortReversed(false);
        }
        if ((column === 'reservedby') && (sortIconCampColumn !== 'reservedby')) {
            setRecomSortReversed(false);
        }
        if ((column === 'status') && (sortIconCampColumn !== 'status')) {
            setRecomSortReversed(false);
        }
        if ((column === 'partsrepairtime') && (sortIconCampColumn !== 'partsrepairtime')) {
            setRecomSortReversed(false);
        }
        setSortIconCampColumn(column);
    }, [sortIconCampColumn]);

    const moveFocusToComm = useCallback((column: string) => {
        if ((column === 'date') && (sortIconCommColumn !== 'date')) {
            setCommSortReversed(false);
        }
        if ((column === 'time') && (sortIconCommColumn !== 'time')) {
            setCommSortReversed(false);
        }
        if ((column === 'type') && (sortIconCommColumn !== 'type')) {
            setCommSortReversed(false);
        }
        if ((column === 'code') && (sortIconCommColumn !== 'code')) {
            setCommSortReversed(false);
        }
        if ((column === 'desc') && (sortIconCommColumn !== 'desc')) {
            setCommSortReversed(false);
        }
        if ((column === 'urgency') && (sortIconCommColumn !== 'urgency')) {
            setCommSortReversed(false);
        }
        if ((column === 'condition') && (sortIconCommColumn !== 'condition')) {
            setCommSortReversed(false);
        }
        if ((column === 'odometer') && (sortIconCommColumn !== 'odometer')) {
            setCommSortReversed(false);
        }
        setSortIconCommColumn(column);
    }, [sortIconCommColumn]);

    const buildString = function (a, b) {
        return a + ' ' + b;
    };

    // Build the selectList options for the dates switcher.
    const commDates : IDropDownItem[] = [
        { label: strings.CurrentMonth, value: 'current' },
        { label: strings.LastMonth, value: 'last' },
        { label: strings.Last6Months, value: 'last6' },
        { label: strings.LastYear, value: 'year' },
        { label: strings.AllDates, value: 'all' },
    ];

    if ((props.connectedVehicle.VIN === '') && (!loadingCV) && (!initialLoadPerformed)) {
        props.getConnectedVehicle();
        setLoadingCV(true);
        setInitialLoadPerformed(true);
    }

    if (invokingCV) {
        setInvokingCV(false);
        props.invokeConnectedVehicle(useTlmId);
        setReloadingCV(true);
    }

    if ((loadingCV) && (props.connectedVehicle.tlmId !== '')) {
        setLoadingCV(false);
    }

    if ((reloadingCV) && (props.connectedVehicle.invokeError === '0000')) {
        setReloadingCV(false);
        props.reloadConnectedVehicle();
    }

    if ((reloadingCV) && (props.connectedVehicle.invokeError === '1000')) {
        setReloadingCV(false);
    }

    let loadingProgress: ReactElement | null = null;
    if (loadingCV || invokingCV || reloadingCV) {
        loadingProgress = <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} />;
    }

    let vehicleInfo: ReactElement | null = null;
    if (props.connectedVehicle.VIN) {
        vehicleInfo = <VehicleInformation />;
    }

    let privacy: ReactElement | null = null;
    if (props.connectedVehicle.privacyStatusCode || props.connectedVehicle.privacyCompanyName ||
        props.connectedVehicle.privacyConsentName || props.connectedVehicle.privacyStartTstamp ||
        props.connectedVehicle.privacyDeviceType || props.connectedVehicle.privacyDeviceValue) {
        privacy = <PrivacyInformation />;
    }

    let lastDataRefresh: ReactElement | null = null;
    if (props.connectedVehicle.addTstamp) {
        let visit: ReactElement | null = null;
        if (props.connectedVehicle.vehicleVisitId || props.connectedVehicle.checkInTstamp || props.connectedVehicle.dealerCode ||
            props.connectedVehicle.dealerName) {
            visit = <VisitInformation />;
        }
        lastDataRefresh =
            <span className={css.statusBlockLastData}>
                <div className={css.iconRow}>
                    <div className={css.statusTagLit}>{strings.LastDataRefresh}</div>
                    {visit}
                </div>
                <div className={css.statusData}>{props.connectedVehicle.addTstamp}</div>
            </span>;
    }

    let telemetry: ReactElement | null = null;
    if (props.connectedVehicle.telemetryTstamp) {
        let telemetryLit = strings.TelemetryLastUpdated;
        if (props.connectedVehicle.parentMake === 'BM') {
            telemetryLit = strings.KeyReadDate;
        }
        telemetry =
            <span className={css.statusBlockLastData}>
                <div className={css.statusTagLit}>
                    {telemetryLit}
                </div>
                <div className={css.statusData}>
                    {props.connectedVehicle.telemetryTstamp}
                </div>
            </span>;
    }

    let buildData: JSX.Element | null = null;
    if (props.connectedVehicle.option && props.connectedVehicle.option.length > 0) {
        buildData = <BuildData />;
    }

    let cvLog: JSX.Element | null = null;
    if (props.connectedVehicle.log && props.connectedVehicle.log.length > 0) {
        cvLog = <CVLog />;
    }

    let cvSettings: JSX.Element | null = null;
    if (props.connectedVehicle.deviceName || props.connectedVehicle.tele || props.connectedVehicle.remTeleCalls ||
        props.connectedVehicle.teleContract || props.connectedVehicle.telemetryTstamp || props.connectedVehicle.sscFlag ||
        props.connectedVehicle.damagedFlag || props.connectedVehicle.vehUpdatedTstamp || props.connectedVehicle.vehCheckCode ||
        props.connectedVehicle.dlrCategory || props.connectedVehicle.vehCategory || props.connectedVehicle.auth ||
        props.connectedVehicle.settingsLocData || props.connectedVehicle.settingsConnect || props.connectedVehicle.settingsData ||
        props.connectedVehicle.safety || props.connectedVehicle.svcConnect || props.connectedVehicle.remoteActive ||
        props.connectedVehicle.digitalKeyRemote || props.connectedVehicle.destinationAssist || props.connectedVehicle.navigation ||
        props.connectedVehicle.virtualAssistant || props.connectedVehicle.integratedStreaming || props.connectedVehicle.wifi) {
        cvSettings = <CVSettings />;
    }

    let mfgInquiry: JSX.Element | null = null;
    if ((props.connectedVehicle.mfgInq && props.connectedVehicle.mfgInq.length > 0) ||
        (props.connectedVehicle.parentMake === 'TY') || (props.connectedVehicle.parentMake === 'LX')) {
        mfgInquiry = <MfgInquiry />;
    }

    let dtc: ReactElement[] | null = null;
    if (props.connectedVehicle.dtc && props.connectedVehicle.dtc.length > 0) {
        const vehDtc = [...props.connectedVehicle.dtc];
        let sortedDtc: DTC[] = [];
        if ((sortIconDtcColumn === 'none') || (sortIconDtcColumn === 'code')) {
            sortedDtc = vehDtc.sort((a, b) => (a.code > b.code ? 1 : -1));
            if (dtcSortReversed) {
                sortedDtc = vehDtc.sort((a, b) => (b.code > a.code ? 1 : -1));
            }
        }
        if (sortIconDtcColumn === 'desc') {
            sortedDtc = vehDtc.sort((a, b) => (a.desc > b.desc ? 1 : -1));
            if (dtcSortReversed) {
                sortedDtc = vehDtc.sort((a, b) => (b.desc > a.desc ? 1 : -1));
            }
        }
        if (sortIconDtcColumn === 'emission') {
            sortedDtc = vehDtc.sort((a, b) => (a.type > b.type ? 1 : -1));
            if (dtcSortReversed) {
                sortedDtc = vehDtc.sort((a, b) => (b.type > a.type ? 1 : -1));
            }
        }
        if (sortIconDtcColumn === 'ecmecu') {
            sortedDtc = vehDtc.sort((a, b) => (a.ecm > b.ecm ? 1 : -1));
            if (dtcSortReversed) {
                sortedDtc = vehDtc.sort((a, b) => (b.ecm > a.ecm ? 1 : -1));
            }
        }
        if (sortIconDtcColumn === 'symptom') {
            sortedDtc = vehDtc.sort((a, b) => (a.symptomDesc > b.symptomDesc ? 1 : -1));
            if (dtcSortReversed) {
                sortedDtc = vehDtc.sort((a, b) => (b.symptomDesc > a.symptomDesc ? 1 : -1));
            }
        }
        if (sortIconDtcColumn === 'status') {
            sortedDtc = vehDtc.sort((a, b) => (a.statusDesc > b.statusDesc ? 1 : -1));
            if (dtcSortReversed) {
                sortedDtc = vehDtc.sort((a, b) => (b.statusDesc > a.statusDesc ? 1 : -1));
            }
        }
        const dtcCount = sortedDtc.length - 1;
        const lastDtc = sortedDtc[dtcCount].code;
        dtc = sortedDtc.map((dtc) => <DTCPanel
            key={dtc.index}
            index={dtc.index}
            lastDtc={lastDtc}
        />);
    }

    let recom: ReactElement[] | null = null;
    if (props.connectedVehicle.recommended && props.connectedVehicle.recommended.length > 0) {
        const vehRecom = [...props.connectedVehicle.recommended];
        let sortedRecom: RECOMMENDED[] = [];
        if ((sortIconRecomColumn === 'none') || (sortIconRecomColumn === 'id')) {
            sortedRecom = vehRecom.sort((a, b) => (a.id > b.id ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.id > a.id ? 1 : -1));
            }
        }
        if (sortIconRecomColumn === 'desc') {
            sortedRecom = vehRecom.sort((a, b) => (a.desc > b.desc ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.desc > a.desc ? 1 : -1));
            }
        }
        if (sortIconRecomColumn === 'source') {
            sortedRecom = vehRecom.sort((a, b) => (a.source > b.source ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.source > a.source ? 1 : -1));
            }
        }
        if (sortIconRecomColumn === 'status') {
            sortedRecom = vehRecom.sort((a, b) => (a.status > b.status ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.status > a.status ? 1 : -1));
            }
        }
        if (sortIconRecomColumn === 'duedate') {
            sortedRecom = vehRecom.sort((a, b) => (a.dueDate > b.dueDate ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.dueDate > a.dueDate ? 1 : -1));
            }
        }
        if (sortIconRecomColumn === 'distance') {
            sortedRecom = vehRecom.sort((a, b) => (a.dueMileSort > b.dueMileSort ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.dueMileSort > a.dueMileSort ? 1 : -1));
            }
        }
        if (sortIconRecomColumn === 'opcode') {
            sortedRecom = vehRecom.sort((a, b) => (a.opCode > b.opCode ? 1 : -1));
            if (recomSortReversed) {
                sortedRecom = vehRecom.sort((a, b) => (b.opCode > a.opCode ? 1 : -1));
            }
        }
        const recomCount = sortedRecom.length - 1;
        const lastRecom = sortedRecom[recomCount].id;
        recom = sortedRecom.map((recom) => <RecommendedPanel
            key={recom.index}
            index={recom.index}
            lastRecom={lastRecom}
        />);
    }

    const isTMNA = ((props.connectedVehicle.parentMake === 'TY' || props.connectedVehicle.parentMake === 'LX') ? true : false);

    const openCamp: CAMPAIGN[] = [];
    if (props.connectedVehicle.campaign && props.connectedVehicle.campaign.length > 0) {
        props.connectedVehicle.campaign.forEach((camp) => {
            if ((camp.status === 'Open') || ((camp.status === 'Not Completed'))) {
                openCamp.push(
                    {
                        code: camp.code,
                        desc: camp.desc,
                        remedy: camp.remedy,
                        remedyAvailable: camp.remedyAvailable,
                        stopSale: camp.stopSale,
                        stopCode: camp.stopCode,
                        startDate: camp.startDate,
                        bulletinId: camp.bulletinId,
                        bulletinUrl: camp.bulletinUrl,
                        recallId: camp.recallId,
                        recallUrl: camp.recallUrl,
                        reservedBy: camp.reservedBy,
                        status: camp.status,
                        repairTime: camp.repairTime,
                        partsReq: camp.partsReq,
                        index: camp.index,
                    },
                );
            }
        });
    }

    let campaigns: ReactElement[] | null = null;
    if (((props.connectedVehicle.campaign && props.connectedVehicle.campaign.length > 0) && !isTMNA) ||
        (isTMNA && openCamp.length > 0)) {
        let vehCamp = [...props.connectedVehicle.campaign];
        if (isTMNA) {
            vehCamp = [...openCamp];
        }
        let sortedCamp: CAMPAIGN[] = [];
        if ((sortIconCampColumn === 'none') || (sortIconCampColumn === 'desc')) {
            sortedCamp = vehCamp.sort((a, b) => (a.desc > b.desc ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.desc > a.desc ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'code') {
            sortedCamp = vehCamp.sort((a, b) => (a.code > b.code ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.code > a.code ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'remedy') {
            sortedCamp = vehCamp.sort((a, b) => (a.remedy > b.remedy ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.remedy > a.remedy ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'stopsale') {
            sortedCamp = vehCamp.sort((a, b) => (a.stopCode > b.stopCode ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.stopCode > a.stopCode ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'startdate') {
            sortedCamp = vehCamp.sort((a, b) => (a.startDate > b.startDate ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.startDate > a.startDate ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'recallbulletin') {
            sortedCamp = vehCamp.sort((a, b) => (a.recallId > b.recallId ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.recallId > a.recallId ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'reservedby') {
            sortedCamp = vehCamp.sort((a, b) => (a.reservedBy > b.reservedBy ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.reservedBy > a.reservedBy ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'status') {
            sortedCamp = vehCamp.sort((a, b) => (a.status > b.status ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.status > a.status ? 1 : -1));
            }
        }
        if (sortIconCampColumn === 'partsrepairtime') {
            sortedCamp = vehCamp.sort((a, b) => (a.repairTime > b.repairTime ? 1 : -1));
            if (campSortReversed) {
                sortedCamp = vehCamp.sort((a, b) => (b.repairTime > a.repairTime ? 1 : -1));
            }
        }
        const campCount = sortedCamp.length - 1;
        const lastCamp = sortedCamp[campCount].code;
        campaigns = sortedCamp.map((campaign) => <CampaignPanel
            key={campaign.index}
            index={campaign.index}
            lastCamp={lastCamp}
        />);
    }

    let mileage: ReactElement | null = null;
    if (props.connectedVehicle.mileage || props.connectedVehicle.mileAvgDistance) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.parentMake === 'BM') {
            statusLit = strings.KeyWriteDate;
        } else if (props.connectedVehicle.mileStatus) {
            statusLit = props.connectedVehicle.mileStatus + ' ' + strings.AsOf;
        }
        let mileageTstamp: ReactElement | null = null;
        if (props.connectedVehicle.mileTstamp) {
            mileageTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.mileTstamp}</p>;
        }
        mileage =
            <div className={css.diagPanel}>
                <div className={css.iconBorderGray}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconOdometer}>
                    </img>
                </div>
                <div className={css.diagData}>
                    <div className={css.diagRow}>
                        <p className={css.diagLit}>{strings.Mileage}</p>
                        <OdometerInformation />
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.mileage}</p>
                    {mileageTstamp}
                </div>
            </div>;
    }

    let battery: ReactElement | null = null;
    if (props.connectedVehicle.battLevel || props.connectedVehicle.battIcon || props.connectedVehicle.battLastUpdTstamp ||
        props.connectedVehicle.battStatus || props.connectedVehicle.battDesc || props.connectedVehicle.battHealth ||
        props.connectedVehicle.battFillLevel || props.connectedVehicle.battElecDte) {
        let batteryIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconBattery}>
                </img>
            </div>;
        if (props.connectedVehicle.battHealth && props.connectedVehicle.battHealth === 'STATUS_BAD') {
            batteryIcon =
                <div className={css.iconBorderRed}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconBattery}>
                    </img>
                </div>;
        }
        if (props.connectedVehicle.battHealth && props.connectedVehicle.battHealth === 'STATUS_MARGINAL') {
            batteryIcon =
                <div className={css.iconBorderGold}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconBattery}>
                    </img>
                </div>;
        }
        if (props.connectedVehicle.battHealth && props.connectedVehicle.battHealth === 'STATUS_GOOD') {
            batteryIcon =
                <div className={css.iconBorderGreen}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconBattery}>
                    </img>
                </div>;
        }
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.parentMake === 'BM') {
            statusLit = strings.KeyWriteDate;
        } else if (props.connectedVehicle.battActualStatus) {
            statusLit = props.connectedVehicle.battActualStatus + ' ' + strings.AsOf;
        }
        let batteryTstamp: ReactElement | null = null;
        if (props.connectedVehicle.battTstamp) {
            batteryTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.battTstamp}</p>;
        }

        battery =
            <div className={css.diagPanel}>
                {batteryIcon}
                <div className={css.diagData}>
                    <div className={css.diagRow}>
                        <p className={css.diagLit}>{strings.BatteryCharge}</p>
                        <BatteryInformation />
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.battLevel}</p>
                    {batteryTstamp}
                </div>
            </div>;
    }

    let fuel: ReactElement | null = null;
    if (props.connectedVehicle.fuelAmt || props.connectedVehicle.fuelMilesPerCapacity || props.connectedVehicle.fuelCity ||
        props.connectedVehicle.fuelEquivCity || props.connectedVehicle.fuelHwy || props.connectedVehicle.fuelEquivHwy ||
        props.connectedVehicle.fuelCombined || props.connectedVehicle.fuelEquivCombined || props.connectedVehicle.fuelDistToEmpty) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.parentMake === 'BM') {
            statusLit = strings.KeyWriteDate;
        } else if (props.connectedVehicle.fuelStatus) {
            statusLit = props.connectedVehicle.fuelStatus + ' ' + strings.AsOf;
        }
        let fuelTstamp: ReactElement | null = null;
        if (props.connectedVehicle.fuelTstamp) {
            fuelTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.fuelTstamp}</p>;
        }
        fuel =
            <div className={css.diagPanel}>
                <div className={css.iconBorderGray}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconGasPump}>
                    </img>
                </div>
                <div className={css.diagData}>
                    <div className={css.diagRow}>
                        <p className={css.diagLit}>{strings.FuelLevel}</p>
                        <FuelInformation />
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.fuelAmt}</p>
                    {fuelTstamp}
                </div>
            </div>;
    }

    let oilImport: ReactElement | null = null;
    if ((props.mode !== 'P') && (props.docType !== 'A') && (props.connectedVehicle.parentMake !== 'TY') &&
        (props.connectedVehicle.parentMake !== 'LX')) {
        if (oilImported) {
            oilImport =
                <div className={css.asterisk}>*</div>;
        }
        if (!oilImported && !lfImported && !rfImported && !lrImported && !rrImported && !spareImported) {
            oilImport =
                <div className={css.checkbox}>
                    <Checkbox
                        id={'oilCheckbox'}
                        size={'rg'}
                        variant={'primaryCkb'}
                        checked={oilChecked}
                        onChange={toggleOil}>
                    </Checkbox>
                </div>;
        }
    }

    let oil: ReactElement | null = null;
    if (props.connectedVehicle.oilLifeValue || props.connectedVehicle.oilIcon || props.connectedVehicle.oilStatus ||
        props.connectedVehicle.oilQtyStatus || props.connectedVehicle.oilDesc || props.connectedVehicle.oilRemainDistance ||
        props.connectedVehicle.oilReplaceIcon || props.connectedVehicle.oilReplaceStatus || props.connectedVehicle.oilReplaceDesc ||
        props.connectedVehicle.oilReplaceTstamp || props.connectedVehicle.oilZeroDays || props.connectedVehicle.oilZeroMonths ||
        props.connectedVehicle.oilZeroYears) {
        let oilIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconFuelDrop}>
                </img>
            </div>;
        if (props.connectedVehicle.oilStatus && props.connectedVehicle.oilStatus === 'STATUS_BAD') {
            oilIcon =
            <div className={css.iconBorderRed}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconFuelDrop}>
                </img>
            </div>;
        }
        if (props.connectedVehicle.oilStatus && props.connectedVehicle.oilStatus === 'STATUS_MARGINAL') {
            oilIcon =
            <div className={css.iconBorderGold}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconFuelDrop}>
                </img>
            </div>;
        }
        if (props.connectedVehicle.oilStatus && props.connectedVehicle.oilStatus === 'STATUS_GOOD') {
            oilIcon =
            <div className={css.iconBorderGreen}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconFuelDrop}>
                </img>
            </div>;
        }
        let oilTstamp: ReactElement | null = null;
        if (props.connectedVehicle.oilTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.oilCheckStatus) {
                statusLit = props.connectedVehicle.oilCheckStatus + ' ' + strings.AsOf;
            }
            oilTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.oilTstamp}</p>;
        }
        oil =
            <div className={css.diagPanel}>
                {oilIcon}
                <div className={css.diagData}>
                    <div className={css.diagRow}>
                        <p className={css.diagLit}>{strings.OilLife}</p>
                        <OilInformation />
                        {oilImport}
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.oilLifeValue}</p>
                    {oilTstamp}
                </div>
            </div>;
    }

    let indicator = strings.IndicatorOff;
    let indicatorIcon =
        <div className={css.iconBorderGreen}>
            <img
                className={css.diagIcon}
                alt=''
                src={IconEngine}>
            </img>
        </div>;
    if (props.connectedVehicle.engineLight === 'Y') {
        indicator = strings.IndicatorOn;
        indicatorIcon =
            <div className={css.iconBorderRed}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconEngine}>
                </img>
            </div>;
    }

    let checkEngineLight: ReactElement | null = null;
    if (props.connectedVehicle.engineLight && props.connectedVehicle.engineLight !== '') {
        checkEngineLight =
            <div className={css.diagPanel}>
                {indicatorIcon}
                <div className={css.diagData}>
                    <p className={css.diagLit}>{strings.CheckEngLight}</p>
                    <p className={css.diagValue}>{indicator}</p>
                </div>
            </div>;
    }

    let lfTire: ReactElement | null = null;
    if (props.connectedVehicle.tirePressLFValue) {
        let lfIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        if (props.connectedVehicle.tireLFValue === 'BAD' || props.connectedVehicle.tireLFValue === 'LOW') {
            lfIcon =
            <div className={css.iconBorderRed}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        }
        if (props.connectedVehicle.tireLFValue === 'MARGINAL') {
            lfIcon =
            <div className={css.iconBorderGold}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        }
        if (props.connectedVehicle.tireLFValue === 'GOOD' || props.connectedVehicle.tireLFValue === 'NORMAL') {
            lfIcon =
            <div className={css.iconBorderGreen}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        }

        let lfTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressLFTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireLFStatus) {
                statusLit = props.connectedVehicle.tireLFStatus + ' ' + strings.AsOf;
            }
            lfTireTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.tirePressLFTstamp}</p>;
        }

        let lfImport: ReactElement | null = null;
        if ((props.mode !== 'P') && (props.docType !== 'A') && (props.connectedVehicle.parentMake !== 'TY') &&
            (props.connectedVehicle.parentMake !== 'LX')) {
            if (lfImported) {
                lfImport =
                    <div className={css.asterisk}>*</div>;
            }
            if (!oilImported && !lfImported && !rfImported && !lrImported && !rrImported && !spareImported) {
                lfImport =
                    <div className={css.checkbox}>
                        <Checkbox
                            id={'lfCheckbox'}
                            size={'rg'}
                            variant={'primaryCkb'}
                            checked={lfChecked}
                            onChange={toggleLf}>
                        </Checkbox>
                    </div>;
            }
        }

        lfTire =
            <div className={css.diagPanel}>
                {lfIcon}
                <div className={css.diagData}>
                    <div className={css.diagTop}>
                        <p className={css.diagLit}>{strings.LFTirePressure}</p>
                        <TireInformation />
                        {lfImport}
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.tirePressLFValue}</p>
                    {lfTireTstamp}
                </div>
            </div>;
    }

    let rfTire: ReactElement | null = null;
    if (props.connectedVehicle.tirePressRFValue) {
        let rfIcon =
        <div className={css.iconBorderGray}>
            <img
                className={css.diagIcon}
                alt=''
                src={IconTire}>
            </img>
        </div>;
        if (props.connectedVehicle.tireRFValue === 'BAD' || props.connectedVehicle.tireRFValue === 'LOW') {
            rfIcon =
                <div className={css.iconBorderRed}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if (props.connectedVehicle.tireRFValue === 'MARGINAL') {
            rfIcon =
                <div className={css.iconBorderGold}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if (props.connectedVehicle.tireRFValue === 'GOOD' || props.connectedVehicle.tireRFValue === 'NORMAL') {
            rfIcon =
                <div className={css.iconBorderGreen}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }

        let rfImport: ReactElement | null = null;
        if ((props.mode !== 'P') && (props.docType !== 'A') && (props.connectedVehicle.parentMake !== 'TY') &&
            (props.connectedVehicle.parentMake !== 'LX')) {
            if (rfImported) {
                rfImport =
                    <div className={css.asterisk}>*</div>;
            }
            if (!oilImported && !lfImported && !rfImported && !lrImported && !rrImported && !spareImported) {
                rfImport =
                <div className={css.checkbox}>
                    <Checkbox
                        id={'rfCheckbox'}
                        size={'rg'}
                        variant={'primaryCkb'}
                        checked={rfChecked}
                        onChange={toggleRf}>
                    </Checkbox>
                </div>;
            }
        }

        let rfTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressRFTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireRFStatus) {
                statusLit = props.connectedVehicle.tireRFStatus + ' ' + strings.AsOf;
            }
            rfTireTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.tirePressRFTstamp}</p>;
        }

        rfTire =
            <div className={css.diagPanel}>
                {rfIcon}
                <div className={css.diagData}>
                    <div className={css.diagTop}>
                        <p className={css.diagLit}>{strings.RFTirePressure}</p>
                        <TireInformation />
                        {rfImport}
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.tirePressRFValue}</p>
                    {rfTireTstamp}
                </div>
            </div>;
    }

    let lrTire: ReactElement | null = null;
    if (props.connectedVehicle.tirePressLRValue) {
        let lrIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        if ((props.connectedVehicle.tireLRValue === 'BAD') || (props.connectedVehicle.tireLRValue === 'LOW') ||
            (props.connectedVehicle.tireILRValue &&
            (props.connectedVehicle.tireILRValue === 'BAD' || props.connectedVehicle.tireILRValue === 'LOW'))) {
            lrIcon =
                <div className={css.iconBorderRed}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if ((props.connectedVehicle.tireLRValue === 'MARGINAL') ||
            ((props.connectedVehicle.tireILRValue) && (props.connectedVehicle.tireILRValue === 'MARGINAL'))) {
            lrIcon =
                <div className={css.iconBorderGold}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if ((props.connectedVehicle.tireLRValue === 'GOOD') || (props.connectedVehicle.tireLRValue === 'NORMAL') ||
            (props.connectedVehicle.tireILRValue &&
            (props.connectedVehicle.tireILRValue === 'GOOD' || props.connectedVehicle.tireILRValue === 'NORMAL'))) {
            lrIcon =
                <div className={css.iconBorderGreen}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }

        let lrImport: ReactElement | null = null;
        if ((props.mode !== 'P') && (props.docType !== 'A') && (props.connectedVehicle.parentMake !== 'TY') &&
            (props.connectedVehicle.parentMake !== 'LX')) {
            if (lrImported) {
                lrImport =
                    <div className={css.asterisk}>*</div>;
            }
            if (!oilImported && !lfImported && !rfImported && !lrImported && !rrImported && !spareImported) {
                lrImport =
                    <div className={css.checkbox}>
                        <Checkbox
                            id={'lrCheckbox'}
                            size={'rg'}
                            variant={'primaryCkb'}
                            checked={lrChecked}
                            onChange={toggleLr}>
                        </Checkbox>
                    </div>;
            }
        }

        let lrValue = props.connectedVehicle.tirePressLRValue;
        if (props.connectedVehicle.tirePressILRValue) {
            lrValue = props.connectedVehicle.tirePressLRValue + ' / ' + props.connectedVehicle.tirePressILRValue +
            ' (' + strings.Outer + ' / ' + strings.Inner + ')';
        }

        let lrTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressLRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireLRStatus) {
                statusLit = props.connectedVehicle.tireLRStatus + ' ' + strings.AsOf;
            }
            lrTireTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.tirePressLRTstamp}</p>;
        }

        lrTire =
            <div className={css.diagPanel}>
                {lrIcon}
                <div className={css.diagData}>
                    <div className={css.diagTop}>
                        <p className={css.diagLit}>{strings.LRTirePressure}</p>
                        <TireInformation />
                        {lrImport}
                    </div>
                    <p className={css.diagValue}>{lrValue}</p>
                    {lrTireTstamp}
                </div>
            </div>;
    }

    let rrTire: ReactElement | null = null;
    if (props.connectedVehicle.tirePressRRValue) {
        let rrIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        if ((props.connectedVehicle.tireRRValue === 'BAD') || (props.connectedVehicle.tireRRValue === 'LOW') ||
            (props.connectedVehicle.tireIRRValue === 'BAD') || (props.connectedVehicle.tireIRRValue === 'LOW')) {
            rrIcon =
                <div className={css.iconBorderRed}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if ((props.connectedVehicle.tireRRValue === 'MARGINAL' || (props.connectedVehicle.tireIRRValue === 'MARGINAL'))) {
            rrIcon =
                <div className={css.iconBorderGold}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if ((props.connectedVehicle.tireRRValue === 'GOOD') || (props.connectedVehicle.tireRRValue === 'NORMAL') ||
            (props.connectedVehicle.tireIRRValue === 'GOOD') || (props.connectedVehicle.tireIRRValue === 'NORMAL')) {
            rrIcon =
                <div className={css.iconBorderGreen}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }

        let rrImport: ReactElement | null = null;
        if ((props.mode !== 'P') && (props.docType !== 'A') && (props.connectedVehicle.parentMake !== 'TY') &&
            (props.connectedVehicle.parentMake !== 'LX')) {
            if (rrImported) {
                rrImport =
                    <div className={css.asterisk}>*</div>;
            }
            if (!oilImported && !lfImported && !rfImported && !lrImported && !rrImported && !spareImported) {
                rrImport =
                    <div className={css.checkbox}>
                        <Checkbox
                            id={'rrCheckbox'}
                            size={'rg'}
                            variant={'primaryCkb'}
                            checked={rrChecked}
                            onChange={toggleRr}>
                        </Checkbox>
                    </div>;
            }
        }

        let rrValue = props.connectedVehicle.tirePressRRValue;
        if (props.connectedVehicle.tirePressIRRValue) {
            rrValue = props.connectedVehicle.tirePressRRValue + ' / ' + props.connectedVehicle.tirePressIRRValue +
            ' (' + strings.Outer + ' / ' + strings.Inner + ')';
        }

        let rrTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressRRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireRRStatus) {
                statusLit = props.connectedVehicle.tireRRStatus + ' ' + strings.AsOf;
            }
            rrTireTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.tirePressRRTstamp}</p>;
        }

        rrTire =
            <div className={css.diagPanel}>
                {rrIcon}
                <div className={css.diagData}>
                    <div className={css.diagTop}>
                        <p className={css.diagLit}>{strings.RRTirePressure}</p>
                        <TireInformation />
                        {rrImport}
                    </div>
                    <p className={css.diagValue}>{rrValue}</p>
                    {rrTireTstamp}
                </div>
            </div>;
    }

    let spareTire: ReactElement | null = null;
    if (props.connectedVehicle.tirePressSpareValue) {
        let spareIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconTire}>
                </img>
            </div>;
        if (props.connectedVehicle.tireSpareValue === 'BAD' || props.connectedVehicle.tireSpareValue === 'LOW') {
            spareIcon =
                <div className={css.iconBorderRed}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if (props.connectedVehicle.tireSpareValue === 'MARGINAL') {
            spareIcon =
                <div className={css.iconBorderGold}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        if (props.connectedVehicle.tireSpareValue === 'GOOD' || props.connectedVehicle.tireSpareValue === 'NORMAL') {
            spareIcon =
                <div className={css.iconBorderGreen}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconTire}>
                    </img>
                </div>;
        }
        let spareTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressSpareTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressSpareStatus) {
                statusLit = props.connectedVehicle.tirePressSpareStatus + ' ' + strings.AsOf;
            }
            spareTireTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.tirePressSpareTstamp}</p>;
        }

        let spareImport: ReactElement | null = null;
        if ((props.mode !== 'P') && (props.docType !== 'A') && (props.connectedVehicle.parentMake !== 'TY') &&
            (props.connectedVehicle.parentMake !== 'LX')) {
            if (spareImported) {
                spareImport =
                    <div className={css.asterisk}>*</div>;
            }
            if (!oilImported && !lfImported && !rfImported && !lrImported && !rrImported && !spareImported) {
                spareImport =
                    <div className={css.checkbox}>
                        <Checkbox
                            id={'spareCheckbox'}
                            size={'rg'}
                            variant={'primaryCkb'}
                            checked={spareChecked}
                            onChange={toggleSpare}>
                        </Checkbox>
                    </div>;
            }
        }

        spareTire =
            <div className={css.diagPanel}>
                {spareIcon}
                <div className={css.diagData}>
                    <div className={css.diagTop}>
                        <p className={css.diagLit}>{strings.SpareTirePressure}</p>
                        <TireInformation />
                        {spareImport}
                    </div>
                    <p className={css.diagValue}>{props.connectedVehicle.tirePressSpareValue}</p>
                    {spareTireTstamp}
                </div>
            </div>;
    }

    let lock: ReactElement | null = null;
    if (props.connectedVehicle.lockValue) {
        let lockValue = strings.Unlocked;
        if (props.connectedVehicle.lockValue && props.connectedVehicle.lockValue === 'Y') {
            lockValue = strings.Locked;
        }
        let lockTstamp: ReactElement | null = null;
        if (props.connectedVehicle.lockTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.lockStatus) {
                statusLit = props.connectedVehicle.lockStatus + ' ' + strings.AsOf;
            }
            lockTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.lockTstamp}</p>;
        }
        lock =
            <div className={css.diagPanel}>
                <div className={css.iconBorderGray}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconSecurity}>
                    </img>
                </div>
                <div className={css.diagData}>
                    <p className={css.diagLit}>{strings.LockStatus}</p>
                    <p className={css.diagValue}>{lockValue}</p>
                    {lockTstamp}
                </div>
            </div>;
    }

    let alarm: ReactElement | null = null;
    if (props.connectedVehicle.alarmValue) {
        let alarmValue = strings.NotSet;
        if (props.connectedVehicle.alarmValue && props.connectedVehicle.alarmValue === 'Y') {
            alarmValue = strings.Set;
        }
        let alarmTstamp: ReactElement | null = null;
        if (props.connectedVehicle.alarmTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.alarmStatus) {
                statusLit = props.connectedVehicle.alarmStatus + ' ' + strings.AsOf;
            }
            alarmTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.alarmTstamp}</p>;
        }
        alarm =
            <div className={css.diagPanel}>
                <div className={css.iconBorderGray}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconAlerts}>
                    </img>
                </div>
                <div className={css.diagData}>
                    <p className={css.diagLit}>{strings.AlarmStatus}</p>
                    <p className={css.diagValue}>{alarmValue}</p>
                    {alarmTstamp}
                </div>
            </div>;
    }

    let remStart: ReactElement | null = null;
    if (props.connectedVehicle.remStartStatusValue) {
        let remStartValue = strings.NotWorking;
        let remStartIcon: ReactElement =
            <div className={css.iconBorderRed}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconKeys}>
                </img>
            </div>;

        if (props.connectedVehicle.remStartStatusValue === 'Y') {
            remStartValue = strings.Working;
            remStartIcon =
                <div className={css.iconBorderGreen}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconKeys}>
                    </img>
                </div>;
        }

        let remStartTstamp: ReactElement | null = null;
        if (props.connectedVehicle.remStartStatusTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.remStartStatusStatus) {
                statusLit = props.connectedVehicle.remStartStatusStatus + ' ' + strings.AsOf;
            }
            remStartTstamp = <p className={css.diagLit}>{statusLit + ' ' + props.connectedVehicle.remStartStatusTstamp}</p>;
        }
        remStart =
            <div className={css.diagPanel}>
                {remStartIcon}
                <div className={css.diagData}>
                    <div className={css.diagRow}>
                        <p className={css.diagLit}>{strings.RemoteStartStatus}</p>
                        <RemoteStartInformation />
                    </div>
                    <p className={css.diagValue}>{remStartValue}</p>
                    {remStartTstamp}
                </div>
            </div>;
    }

    let exhaust: ReactElement | null = null;
    if (props.connectedVehicle.exhaustValue) {
        exhaust =
            <div className={css.diagPanel}>
                <div className={css.iconBorderGray}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconFuelDrop}>
                    </img>
                </div>
                <div className={css.diagData}>
                    <p className={css.diagLit}>{strings.ExhaustFluid}</p>
                    <p className={css.diagValue}>{props.connectedVehicle.exhaustValue}</p>
                </div>
            </div>;
    }

    let airFilter: ReactElement | null = null;
    if (props.connectedVehicle.airFilterValue) {
        airFilter =
            <div className={css.diagPanel}>
                <div className={css.iconBorderGray}>
                    <img
                        className={css.diagIcon}
                        alt=''
                        src={IconAirFilter}>
                    </img>
                </div>
                <div className={css.diagData}>
                    <p className={css.diagLit}>{strings.EngineAirFilter}</p>
                    <p className={css.diagValue}>{props.connectedVehicle.airFilterValue}</p>
                </div>
            </div>;
    }

    let locTstamp: ReactElement | null = null;
    if (props.connectedVehicle.locTstamp) {
        locTstamp = <p className={css.diagLit}>{strings.DataFrom + ' ' + props.connectedVehicle.locTstamp}</p>;
    }

    let vrcIcon =
        <div className={css.iconBorderGreen}>
            <img
                className={css.diagIcon}
                alt=''
                src={IconError}>
            </img>
        </div>;
    if (openCamp.length > 0) {
        vrcIcon =
            <div className={css.iconBorderRed}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconError}>
                </img>
            </div>;
    }

    let dtcIcon =
        <div className={css.iconBorderGreen}>
            <img
                className={css.diagIcon}
                alt=''
                src={IconClientCare}>
            </img>
        </div>;
    if (props.connectedVehicle.dtcActive === '999') {
        dtcIcon =
            <div className={css.iconBorderGray}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconClientCare}>
                </img>
            </div>;
    } else if (Number(props.connectedVehicle.dtcActive) > 0) {
        dtcIcon =
            <div className={css.iconBorderRed}>
                <img
                    className={css.diagIcon}
                    alt=''
                    src={IconClientCare}>
                </img>
            </div>;
    }

    let dtcCount: ReactElement =
        <p className={css.statusData}>{'0 ' + strings.DTCShort}</p>;

    let dtcLink: ReactElement = dtcCount;

    if (props.connectedVehicle.dtc && props.connectedVehicle.dtc.length > 0) {
        dtcCount = <p className={css.statusData}>{props.connectedVehicle.dtc.length + ' ' + strings.DTCShort}</p>;
        dtcLink =
            <Link
                id='dtcLink'
                onClick={scrollDtc}
                className={css.dtcLink}>
                {dtcCount}
            </Link>;
    }

    const dtcText: ReactElement =
        <div className={css.diagData}>
            <p className={css.statusTagLit}>{strings.DTCHeader}</p>
            {dtcLink}
        </div>;

    let diagnosticsTop: ReactElement | null = null;
    if ((props.connectedVehicle.campaign && props.connectedVehicle.campaign.length > 0) ||
        (props.connectedVehicle.dtc && props.connectedVehicle.dtc.length > 0)) {
        diagnosticsTop =
            <div className={css.diagnostics}>
                <div className={css.diagPanel}>
                    {vrcIcon}
                    <div className={css.diagData}>
                        <p className={css.statusTagLit}>{strings.RecallsAndCampaigns}</p>
                        <p className={css.statusData}>{openCamp.length + ' ' + strings.OpenCampaigns}</p>
                    </div>
                </div>
                <div className={css.diagPanel}>
                    {dtcIcon}
                    {dtcText}
                </div>
            </div>;
    }

    let dealerVisits: ReactElement | null = null;
    if (props.connectedVehicle.numVisits) {
        dealerVisits =
            <span className={css.statusBlock}>
                <div className={css.statusTagLit}>{strings.DealershipVisits}</div>
                <div className={css.statusData}>{props.connectedVehicle.numVisits}</div>
            </span>;
    }

    let repeatVisitsValue: string | null = null;
    if (props.connectedVehicle.rptVisitCount) {
        repeatVisitsValue = props.connectedVehicle.rptVisitCount;
    }
    if (props.connectedVehicle.rptVisitStatus) {
        repeatVisitsValue = props.connectedVehicle.rptVisitStatus;
    }
    if (props.connectedVehicle.rptVisitCount && props.connectedVehicle.rptVisitStatus) {
        repeatVisitsValue = props.connectedVehicle.rptVisitCount + ' - ' + props.connectedVehicle.rptVisitStatus;
    }

    let repeatVisitsLink: ReactElement =
        <div className={css.statusData}>{repeatVisitsValue}</div>;

    if (props.connectedVehicle.rptVisitUrl) {
        repeatVisitsLink =
            <div>
                <Link
                    id='RepeatVisitsLink'
                    url={props.connectedVehicle.rptVisitUrl}
                    className={css.url}>
                    <div>{repeatVisitsValue}</div>
                </Link>
            </div>;
    }

    let repeatVisits: ReactElement | null = null;
    if (props.connectedVehicle.rptVisitCount || props.connectedVehicle.rptVisitStatus) {
        repeatVisits =
            <span className={css.statusBlock}>
                <div className={css.statusTagLit}>{strings.RepeatVisits}</div>
                {repeatVisitsLink}
            </span>;
    }

    let diagnostics: ReactElement | null = null;
    if (mileage || battery || oil || checkEngineLight || lfTire || rfTire || lrTire || rrTire || spareTire || fuel || lock ||
        alarm ||remStart || exhaust || airFilter) {
        let separator: ReactElement | null = null;
        if (diagnosticsTop) {
            separator = <hr className={css.statusHr}></hr>;
        }
        diagnostics =
            <div>
                {separator}
                <div className={css.diagnostics}>
                    {mileage}
                    {battery}
                    {oil}
                    {checkEngineLight}
                    {lfTire}
                    {rfTire}
                    {lrTire}
                    {rrTire}
                    {spareTire}
                    {fuel}
                    {exhaust}
                    {airFilter}
                    {lock}
                    {alarm}
                    {remStart}
                </div>
            </div>;
    }

    let geoLocation: ReactElement | null = null;
    if (props.connectedVehicle.locLatitude && props.connectedVehicle.locLongitude) {
        geoLocation =
            <span className={css.statusBlock}>
                <div className={css.statusTagLit}>{strings.VehicleLocation}</div>
                <GeoLocation />
                {locTstamp}
            </span>;
    }

    let serviceHistory: ReactElement | null = null;
    if (props.connectedVehicle.firstRoDate || props.connectedVehicle.lastRoNum || props.connectedVehicle.lastRoDate ||
        props.connectedVehicle.lastRoMile || (props.connectedVehicle.svcHist && (props.connectedVehicle.svcHist.length > 0))) {
        serviceHistory =
            <span className={css.statusBlock}>
                <div className={css.statusTagLit}>{strings.ServiceHistory}</div>
                <ServiceHistory />
            </span>;
    }

    let deepSleep: ReactElement | null = null;
    if (props.connectedVehicle.deepSleepValue) {
        deepSleep =
        <span className={css.statusBlock}>
            <p className={css.statusTagLit}>{strings.DeepSleep}</p>
            <p className={css.statusData}>{props.connectedVehicle.deepSleepValue}</p>
            <p className={css.diagLit}>{strings.DataFrom + ' ' + props.connectedVehicle.deepSleepTstamp}</p>
        </span>;
    }

    let firmware: ReactElement | null = null;
    if (props.connectedVehicle.firmwareValue) {
        firmware =
        <span className={css.statusBlock}>
            <p className={css.statusTagLit}>{strings.FirmwareUpdate}</p>
            <p className={css.statusData}>{props.connectedVehicle.firmwareValue}</p>
            <p className={css.diagLit}>{strings.DataFrom + ' ' + props.connectedVehicle.firmwareTstamp}</p>
        </span>;
    }

    let evHybridData: ReactElement | null = null;
    if (props.connectedVehicle.plugValue || props.connectedVehicle.hybridValue || props.connectedVehicle.chargeValue ||
        props.connectedVehicle.chargeStartValue || props.connectedVehicle.chargeEndValue) {
        evHybridData =
            <span className={css.statusBlock}>
                <div className={css.statusTagLit}>{strings.EvHybridData}</div>
                <EvHybridInformation />
            </span>;
    }

    let diagnosticsBottom1: ReactElement | null = null;
    if (geoLocation || dealerVisits || repeatVisits || serviceHistory) {
        let separator: ReactElement | null = null;
        if (diagnosticsTop || diagnostics) {
            separator = <hr className={css.statusHr}></hr>;
        }
        diagnosticsBottom1 =
            <div>
                {separator}
                <div className={css.diagnosticsPanel}>
                    {geoLocation}
                    {dealerVisits}
                    {repeatVisits}
                    {serviceHistory}
                </div>
            </div>;
    }

    let diagnosticsBottom2: ReactElement | null = null;
    if (deepSleep || firmware || evHybridData) {
        diagnosticsBottom2 =
            <div>
                <hr className={css.statusHr}></hr>
                <div className={css.diagnosticsPanel}>
                    {deepSleep}
                    {firmware}
                    {evHybridData}
                </div>
            </div>;
    }

    let statusIcon: ReactElement | null = null;
    let vehStatusFields: ReactElement | null = null;
    if (statusOpen && (diagnosticsTop || diagnostics || diagnosticsBottom1 || diagnosticsBottom2)) {
        let importButton: ReactElement =
            <div className={css.buttonDisabled}>{strings.ImportSelectedStatuses}</div>;
        let selectButton: ReactElement =
            <div className={css.buttonDisabled}>{strings.SelectAllStatuses}</div>;
        if (props.mode !== 'P' && (!lfImported && !rfImported && !lrImported && !rrImported && !spareImported && !oilImported)) {
            selectButton =
                <div id='selectButton' className={css.button} onClick={checkAll}>
                    {strings.SelectAllStatuses}
                </div>;
            if (lfChecked || rfChecked || lrChecked || rrChecked || spareChecked || oilChecked) {
                importButton =
                    <div id='importButton' className={css.button} onClick={importTirePressure}>
                        {strings.ImportSelectedStatuses}
                    </div>;
            }
        }
        let diagnosticsButtons: ReactElement | null = null;
        if (props.docType !== 'A' && (lfTire || rfTire || lrTire || rrTire || spareTire || oil) &&
            (props.connectedVehicle.parentMake !== 'TY') && (props.connectedVehicle.parentMake !== 'LX')) {
            diagnosticsButtons =
                <div className={css.buttonArea}>
                    {selectButton}
                    {importButton}
                </div>;
        }
        statusIcon = <IconDropDownReverse id='statusIcon' className={css.statusIcon} onClick={() => toggleStatus()} />;
        vehStatusFields =
            <div>
                {diagnosticsButtons}
                {diagnosticsTop}
                {diagnostics}
                {diagnosticsBottom1}
                {diagnosticsBottom2}
            </div>;
    } else {
        statusIcon = <IconDropDown id='statusIcon2' className={css.statusIcon} onClick={() => toggleStatus()} />;
    }

    let vehStatusArea: ReactElement | null = null;
    if (diagnosticsTop || diagnostics || diagnosticsBottom1 || diagnosticsBottom2) {
        vehStatusArea =
            <div>
                <span id='vehStatus' className={css.vehStatus} onClick={() => toggleStatus()}>
                    <div className={css.statusText}>{strings.VehStatus}</div>
                    {statusIcon}
                </span>
                {vehStatusFields}
            </div>;
    }

    let vehDesc = strings.ConnectedVehicle;
    if ((props.connectedVehicle.year) || (props.connectedVehicle.make) || (props.connectedVehicle.modelDesc)) {
        vehDesc = buildString(vehDesc, ' - ');
        if (props.connectedVehicle.year) {
            vehDesc = buildString(vehDesc, props.connectedVehicle.year);
        }
        if (props.connectedVehicle.make) {
            vehDesc = buildString(vehDesc, props.connectedVehicle.make.toUpperCase());
        }
        if (props.connectedVehicle.modelDesc) {
            vehDesc = buildString(vehDesc, props.connectedVehicle.modelDesc.toUpperCase());
        }
    }
    const clientLit = strings.Client.toUpperCase() + ': ';
    if (props.connectedVehicle.custName) {
        vehDesc = buildString(vehDesc, '(');
        vehDesc = buildString(vehDesc, clientLit);
        vehDesc = buildString(vehDesc, props.connectedVehicle.custName.toUpperCase());
        vehDesc = buildString(vehDesc, ')');
    }

    let maintContracts: ReactElement | null = null;
    if (props.connectedVehicle.mc || props.connectedVehicle.ac || props.connectedVehicle.xc) {
        maintContracts = <Contracts />;
    }

    let pastRecalls: ReactElement | null = null;
    if (isTMNA && (props.connectedVehicle.campaign.some((result) => (result.status!== 'Not Completed')))) {
        pastRecalls = <PastRecalls />;
    }

    let dtcViewIcon: ReactElement | null = null;
    let dtcFields: ReactElement | null = null;
    if (dtcOpen) {
        dtcViewIcon = <IconDropDownReverse id='dtcViewIcon' className={css.dtcIcon} onClick={() => toggleDtcArea()} />;
        let selectAllButton: ReactElement =
            <div className={css.buttonDisabled}>
                {strings.SelectAllDTC}
            </div>;
        let importSelectedButton: ReactElement =
            <div className={css.buttonDisabled}>
                {strings.ImportSelectedDTC}
            </div>;
        if (props.mode !== 'P' && (props.connectedVehicle.dtc && (props.connectedVehicle.dtc.length > 0))) {
            selectAllButton =
                <div id='selectAllDtc' className={css.button} onClick={() => toggleAllDtc()}>
                    {strings.SelectAllDTC}
                </div>;
        }
        if (props.mode !== 'P' && (props.checkedDtc && (props.checkedDtc.length > 0))) {
            importSelectedButton =
                <div id='importDtcButton' className={css.button} onClick={() => importDtc()}>
                    {strings.ImportSelectedDTC}
                </div>;
        }
        let dtcCodeSortIcon: ReactElement | null = null;
        if (sortIconDtcColumn === 'code') {
            dtcCodeSortIcon =
                <IconSortAscending id='dtcCodeSortIcon' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            if (dtcSortReversed) {
                dtcCodeSortIcon =
                    <IconSortDescending id='dtcCodeSortIcon2' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            }
        }
        let dtcDescSortIcon: ReactElement | null = null;
        if (sortIconDtcColumn === 'desc') {
            dtcDescSortIcon =
                <IconSortAscending id='dtcDescSortIcon' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            if (dtcSortReversed) {
                dtcDescSortIcon =
                    <IconSortDescending id='dtcDescSortIcon2' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            }
        }
        let dtcEmissionSortIcon: ReactElement | null = null;
        if (sortIconDtcColumn === 'emission') {
            dtcEmissionSortIcon =
                <IconSortAscending id='dtcEmissionSortIcon' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            if (dtcSortReversed) {
                dtcEmissionSortIcon =
                    <IconSortDescending id='dtcEmissionSortIcon2' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            }
        }
        let dtcEcmecuSortIcon: ReactElement | null = null;
        if (sortIconDtcColumn === 'ecmecu') {
            dtcEcmecuSortIcon =
                <IconSortAscending id='dtcEcmecuSortIcon' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            if (dtcSortReversed) {
                dtcEcmecuSortIcon =
                    <IconSortDescending id='dtcEcmecuSortIcon2' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            }
        }
        let dtcSymptomSortIcon: ReactElement | null = null;
        if (sortIconDtcColumn === 'symptom') {
            dtcSymptomSortIcon =
                <IconSortAscending id='dtcSymptomSortIcon' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            if (dtcSortReversed) {
                dtcSymptomSortIcon =
                    <IconSortDescending id='dtcSymptomSortIcon2' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            }
        }
        let dtcStatusSortIcon: ReactElement | null = null;
        if (sortIconDtcColumn === 'status') {
            dtcStatusSortIcon =
                <IconSortAscending id='dtcStatusSortIcon' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            if (dtcSortReversed) {
                dtcStatusSortIcon =
                    <IconSortDescending id='dtcStatusSortIcon2' className={css.dtcSortIcon} onClick={() => reverseDtcSort()}/>;
            }
        }
        dtcFields =
        <div>
            {selectAllButton}
            {importSelectedButton}
            <div className={css.litRow}>
                <div className={css.iconColumn} />
                <div className={css.dtcCodeArea}>
                    <div id='dtcCodeLit' className={css.dtcCodeLit} onClick={() => moveFocusToDtc('code')}>
                        {strings.TroubleCode}
                    </div>
                    {dtcCodeSortIcon}
                </div>
                <div className={css.dtcDescArea}>
                    <div id='dtcDescLit' className={css.dtcDescLit} onClick={() => moveFocusToDtc('desc')}>
                        {strings.Description}
                    </div>
                    {dtcDescSortIcon}
                </div>
                <div className={css.dtcEmissionArea}>
                    <div id='dtcEmissionLit' className={css.dtcEmissionLit} onClick={() => moveFocusToDtc('emission')}>
                        {strings.EmissionDTC}
                    </div>
                    {dtcEmissionSortIcon}
                </div>
                <div className={css.dtcECMECUArea}>
                    <div id='dtcECMECULit' className={css.dtcECMECULit} onClick={() => moveFocusToDtc('ecmecu')}>
                        {strings.ECMECU}
                    </div>
                    {dtcEcmecuSortIcon}
                </div>
                <div className={css.dtcSymptomArea}>
                    <div id='dtcSymptomLit' className={css.dtcSymptomLit} onClick={() => moveFocusToDtc('symptom')}>
                        {strings.SymptomCode}
                    </div>
                    {dtcSymptomSortIcon}
                </div>
                <div className={css.dtcStatusArea}>
                    <div id='dtcStatusLit' className={css.dtcStatusLit} onClick={() => moveFocusToDtc('status')}>
                        {strings.CVStatus}
                    </div>
                    {dtcStatusSortIcon}
                </div>
            </div>
            {dtc}
        </div>;
    } else {
        dtcViewIcon = <IconDropDown id='dtcViewIcon2' className={css.dtcIcon} onClick={() => toggleDtcArea()} />;
    }

    let dtcArea: ReactElement | null = null;
    if ((props.connectedVehicle.dtc) && (props.connectedVehicle.dtc.length > 0)) {
        dtcArea =
            <div id='dtcAreaDiv' className={css.dtcArea}>
                <span id='dtcHeader' className={css.maintHeader} onClick={() => toggleDtcArea()}>
                    <img
                        className={css.maintImage}
                        alt=''
                        src={IconClientCare}>
                    </img>
                    <div className={css.maintHeaderText}>{strings.DTCHeader}</div>
                    {dtcViewIcon}
                </span>
                <hr className={css.dataLine}></hr>
                {dtcFields}
            </div>;
    }

    let recomArea: ReactElement | null = null;
    if ((props.connectedVehicle.recommended) && (props.connectedVehicle.recommended.length > 0)) {
        let recomIcon: ReactElement | null = null;
        let recomFields: ReactElement | null = null;
        if (recomOpen) {
            recomIcon = <IconDropDownReverse id='recomIcon' className={css.recomIcon} onClick={() => toggleRecom()} />;
            let selectAllButton: ReactElement =
                <div className={css.buttonDisabled}>
                    {strings.SelectAllRecom}
                </div>;
            let importSelectedButton: ReactElement =
                <div className={css.buttonDisabled}>
                    {strings.ImportSelectedRecom}
                </div>;
            if (props.mode !== 'P' && props.connectedVehicle.recommended.length > 0) {
                selectAllButton =
                    <div id='selectAllRecom' className={css.button} onClick={() => toggleAllRecommended()}>
                        {strings.SelectAllRecom}
                    </div>;
            }
            if (props.mode !== 'P' && props.checkedRecommended.length > 0) {
                importSelectedButton =
                    <div id='importRecomButton' className={css.button} onClick={() => importRecommended()}>
                        {strings.ImportSelectedRecom}
                    </div>;
            }
            let recomIdSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'id') {
                recomIdSortIcon =
                    <IconSortAscending id='recomIdSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomIdSortIcon =
                        <IconSortDescending
                            id='recomIdSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            let recomDescSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'desc') {
                recomDescSortIcon =
                    <IconSortAscending id='recomDescSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomDescSortIcon =
                        <IconSortDescending
                            id='recomDescSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            let recomSourceSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'source') {
                recomSourceSortIcon =
                    <IconSortAscending id='recomSourceSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomSourceSortIcon =
                        <IconSortDescending
                            id='recomSourceSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            let recomStatusSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'status') {
                recomStatusSortIcon =
                    <IconSortAscending id='recomStatusSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomStatusSortIcon =
                        <IconSortDescending
                            id='recomStatusSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            let recomDuedateSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'duedate') {
                recomDuedateSortIcon =
                    <IconSortAscending id='recomDuedateSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomDuedateSortIcon =
                        <IconSortDescending
                            id='recomDuedateSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            let recomDistanceSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'distance') {
                recomDistanceSortIcon =
                    <IconSortAscending
                        id='recomDistanceSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomDistanceSortIcon =
                        <IconSortDescending
                            id='recomDistanceSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            let recomOpcodeSortIcon: ReactElement | null = null;
            if (sortIconRecomColumn === 'opcode') {
                recomOpcodeSortIcon =
                    <IconSortAscending id='recomOpcodeSortIcon' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                if (recomSortReversed) {
                    recomOpcodeSortIcon =
                        <IconSortDescending
                            id='recomOpcodeSortIcon2' className={css.recomSortIcon} onClick={() => reverseRecomSort()}/>;
                }
            }
            recomFields =
                <div>
                    {selectAllButton}
                    {importSelectedButton}
                    <div className={css.litRow}>
                        <div className={css.iconColumn} />
                        <div className={css.recomIdArea}>
                            <div id='recomIdLit' className={css.recomIdLit} onClick={() => moveFocusToRecom('id')}>
                                {strings.ID}
                            </div>
                            {recomIdSortIcon}
                        </div>
                        <div className={css.recomDescArea}>
                            <div id='recomDescLit' className={css.recomDescLit} onClick={() => moveFocusToRecom('desc')}>
                                {strings.Description}
                            </div>
                            {recomDescSortIcon}
                        </div>
                        <div className={css.recomSourceArea}>
                            <div id='recomSourceLit' className={css.recomSourceLit} onClick={() => moveFocusToRecom('source')}>
                                {strings.Source}
                            </div>
                            {recomSourceSortIcon}
                        </div>
                        <div className={css.recomStatusArea}>
                            <div id='recomStatusLit' className={css.recomStatusLit} onClick={() => moveFocusToRecom('status')}>
                                {strings.CVStatus}
                            </div>
                            {recomStatusSortIcon}
                        </div>
                        <div className={css.recomDueDateArea}>
                            <div id='recomDueDateLit' className={css.recomDueDateLit} onClick={() => moveFocusToRecom('duedate')}>
                                {strings.DueDate}
                            </div>
                            {recomDuedateSortIcon}
                        </div>
                        <div className={css.recomDueMilesArea}>
                            <div
                                id='recomDueMilesLit'
                                className={css.recomDueMilesLit}
                                onClick={() => moveFocusToRecom('distance')}>
                                {strings.Distance}
                            </div>
                            {recomDistanceSortIcon}
                        </div>
                        <div className={css.recomOpCodeArea}>
                            <div id='recomOpCodeLit' className={css.recomOpCodeLit} onClick={() => moveFocusToRecom('opcode')}>
                                {strings.OpCode}
                            </div>
                            {recomOpcodeSortIcon}
                        </div>
                    </div>
                    {recom}
                </div>;
        } else {
            recomIcon = <IconDropDown id='recomIcon2' className={css.recomIcon} onClick={() => toggleRecom()} />;
        }

        recomArea =
            <div className={css.recomArea}>
                <span id='recomHeader' className={css.maintHeader} onClick={() => toggleRecom()}>
                    <div className={css.recomHeaderText}>{strings.RecommendedMaintenance}</div>
                    {recomIcon}
                </span>
                <hr className={css.dataLine}></hr>
                {recomFields}
            </div>;
    }

    let campaignIcon: ReactElement | null = null;
    let campaignFields: ReactElement | null = null;
    if (campaignOpen) {
        campaignIcon = <IconDropDownReverse id='campaignIcon' className={css.campaignIcon} onClick={() => toggleCampaign()} />;
        const enableButton = (isTMNA && (!openCamp.some(result => (result.remedyAvailable === 'Y')))) ? false : true;
        let selectAllButton: ReactElement =
            <div className={css.buttonDisabled}>
                {strings.SelectAllCampaigns}
            </div>;
        let importSelectedButton: ReactElement =
            <div className={css.buttonDisabled}>
                {strings.ImportSelectedCampaigns}
            </div>;
        if (props.mode !== 'P' && (props.connectedVehicle.campaign && (props.connectedVehicle.campaign.length > 0)) &&
           (enableButton)) {
            selectAllButton =
                <div id='selectAllCampaign' className={css.button} onClick={() => toggleAllCampaign()}>
                    {strings.SelectAllCampaigns}
                </div>;
        }
        if (props.mode !== 'P' && (props.checkedCampaign && (props.checkedCampaign.length > 0))) {
            importSelectedButton =
                <div id='importCampaignButton' className={css.button} onClick={() => importCampaign()}>
                    {strings.ImportSelectedCampaigns}
                </div>;
        }
        let campDescSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'desc') {
            campDescSortIcon =
                <IconSortAscending id='campDescSortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campDescSortIcon =
                    <IconSortDescending id='campDescSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campCodeSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'code') {
            campCodeSortIcon =
                <IconSortAscending id='campCodeSortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campCodeSortIcon =
                    <IconSortDescending id='campCodeSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campRemedySortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'remedy') {
            campRemedySortIcon =
                <IconSortAscending id='campRemedySortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campRemedySortIcon =
                    <IconSortDescending id='campRemedySortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campStopsaleSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'stopsale') {
            campStopsaleSortIcon =
                <IconSortAscending id='campStopsaleSortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campStopsaleSortIcon =
                    <IconSortDescending id='campStopsaleSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campStartdateSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'startdate') {
            campStartdateSortIcon =
                <IconSortAscending id='campStartdateSortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campStartdateSortIcon =
                    <IconSortDescending
                        id='campStartdateSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campRecallbulletinSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'recallbulletin') {
            campRecallbulletinSortIcon =
                <IconSortAscending id='campRecallbulletinSortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campRecallbulletinSortIcon =
                    <IconSortDescending
                        id='campRecallbulletinSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campReservedbySortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'reservedby') {
            campReservedbySortIcon =
                <IconSortAscending id='campReservedbySortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campReservedbySortIcon =
                    <IconSortDescending
                        id='campReservedbySortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campStatusSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'status') {
            campStatusSortIcon =
                <IconSortAscending id='campStatusSortIcon' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            if (campSortReversed) {
                campStatusSortIcon =
                    <IconSortDescending id='campStatusSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        let campPartsrepairtimeSortIcon: ReactElement | null = null;
        if (sortIconCampColumn === 'partsrepairtime') {
            campPartsrepairtimeSortIcon =
                <IconSortAscending
                    id='campPartsrepairtimeSortIcon'
                    className={css.campSortIcon}
                    onClick={() => reverseCampSort()}
                />;
            if (campSortReversed) {
                campPartsrepairtimeSortIcon =
                    <IconSortDescending
                        id='campPartsrepairtimeSortIcon2' className={css.campSortIcon} onClick={() => reverseCampSort()}/>;
            }
        }
        campaignFields =
            <div>
                {selectAllButton}
                {importSelectedButton}
                <div className={css.litRow}>
                    <div className={css.iconColumn2} />
                    <div className={css.campDescArea}>
                        <div id='campDescLit' className={css.campDescLit} onClick={() => moveFocusToCamp('desc')}>
                            {strings.Description}
                        </div>
                        {campDescSortIcon}
                    </div>
                    <div className={css.campCodeArea}>
                        <div id='campCodeLit' className={css.campCodeLit} onClick={() => moveFocusToCamp('code')}>
                            {strings.CampaignCode}
                        </div>
                        {campCodeSortIcon}
                    </div>
                    <div className={css.campRemedyArea}>
                        <div id='campRemedyLit' className={css.campRemedyLit} onClick={() => moveFocusToCamp('remedy')}>
                            {strings.Remedy}
                        </div>
                        {campRemedySortIcon}
                    </div>
                    <div className={css.campStopSaleArea}>
                        <div id='campStopSaleLit' className={css.campStopSaleLit} onClick={() => moveFocusToCamp('stopsale')}>
                            <div>{strings.StopSale}/</div>
                            <div>{strings.StopSaleCode}</div>
                        </div>
                        {campStopsaleSortIcon}
                    </div>
                    <div className={css.campStartDateArea}>
                        <div id='campStartDateLit' className={css.campStartDateLit} onClick={() => moveFocusToCamp('startdate')}>
                            {strings.StartDate}
                        </div>
                        {campStartdateSortIcon}
                    </div>
                    <div className={css.campRecallBulletinArea}>
                        <div
                            id='campRecallBulletinLit'
                            className={css.campRecallBulletinLit}
                            onClick={() => moveFocusToCamp('recallbulletin')}>
                            <div>{strings.RecallId}/</div>
                            <div>{strings.BulletinId}</div>
                        </div>
                        {campRecallbulletinSortIcon}
                    </div>
                    <div className={css.campReservedByArea}>
                        <div id='campReservedByLit' className={css.campReservedByLit} onClick={() => moveFocusToCamp('reservedby')}>
                            {strings.ReservedByDealership}
                        </div>
                        {campReservedbySortIcon}
                    </div>
                    <div className={css.campStatusArea}>
                        <div id='campStatusLit' className={css.campStatusLit} onClick={() => moveFocusToCamp('status')}>
                            {strings.CVStatus}
                        </div>
                        {campStatusSortIcon}
                    </div>
                    <div className={css.campPartsRepairTimeArea}>
                        <div
                            id='campPartsRepairTimeLit'
                            className={css.campPartsRepairTimeLit}
                            onClick={() => moveFocusToCamp('partsrepairtime')}>
                            <div>{strings.PartsRequired}/</div>
                            <div>{strings.RepairTime}</div>
                        </div>
                        {campPartsrepairtimeSortIcon}
                    </div>
                </div>
                {campaigns}
            </div>;
    } else {
        campaignIcon = <IconDropDown id='campaignIcon2' className={css.campaignIcon} onClick={() => toggleCampaign()} />;
    }

    let campaignArea: ReactElement | null = null;
    if ((((props.connectedVehicle.campaign) && (props.connectedVehicle.campaign.length > 0)) && !isTMNA) ||
        ((isTMNA) && (openCamp.length > 0))) {
        campaignArea =
            <div className={css.campArea}>
                <div id='campaignHeader' className={css.maintHeader} onClick={() => toggleCampaign()}>
                    <img
                        className={css.maintImage}
                        alt=''
                        src={IconError}>
                    </img>
                    <div className={css.maintHeaderText}>{strings.RecallsAndCampaigns}</div>
                    {campaignIcon}
                </div>
                <hr className={css.dataLine}></hr>
                {campaignFields}
            </div>;
    }

    let maintenanceContracts: ReactElement | null = null;
    if ((props.connectedVehicle.mc && props.connectedVehicle.mc.length > 0) ||
        (props.connectedVehicle.ac && props.connectedVehicle.ac.length > 0) ||
        (props.connectedVehicle.xc && props.connectedVehicle.xc.length > 0)) {
        maintenanceContracts =
            <div className={css.contractsArea}>
                <div className={css.maintHeader}>
                    {maintContracts}
                </div>
            </div>;
    }

    let pastRecallArea: ReactElement | null = null;
    if (isTMNA && (props.connectedVehicle.campaign.some((result) => (result.status !== 'Not Completed')))) {
        pastRecallArea =
            <div className={css.pastRecallsArea}>
                <div className={css.maintHeader}>
                    {pastRecalls}
                </div>
            </div>;
    }

    let vehMaintBottom: ReactElement | null = null;
    if (maintenanceContracts || pastRecallArea) {
        vehMaintBottom =
            <div>
                <hr className=
                    {(campaignArea && campaignOpen) ||
                    (!campaignArea && recomArea && recomOpen) ||
                    (!recomArea && !campaignArea && dtcArea && dtcOpen) ? css.dataLine : css.hidden}>
                </hr>
                <div className={css.vehMaintBottom}>
                    <span className={css.vehMaintBlockBuild}>
                        {maintenanceContracts}
                        {pastRecallArea}
                    </span>
                </div>
            </div>;
    }

    let maintIcon: ReactElement | null = null;
    let maintFields: ReactElement | null = null;
    if (maintOpen) {
        maintIcon = <IconDropDownReverse id='maintIcon' className={css.maintIcon} onClick={() => toggleMaint()} />;
        maintFields =
        <div>
            {dtcArea}
            {recomArea}
            {campaignArea}
            {vehMaintBottom}
        </div>;
    } else {
        maintIcon = <IconDropDown id='maintIcon2' className={css.maintIcon} onClick={() => toggleMaint()} />;
    }

    let vehMaint: ReactElement | null = null;
    if (dtcArea || recomArea || campaignArea || vehMaintBottom) {
        vehMaint =
            <div>
                <span id='vehMaint' className={css.vehMaint} onClick={() => toggleMaint()}>
                    <div className={css.statusText}>{strings.VehMaintenance}</div>
                    {maintIcon}
                </span>
                {maintFields}
            </div>;
    }

    let statusBottom2: ReactElement | null = null;
    if (props.connectedVehicle.log || buildData || mfgInquiry || lfImported || rfImported || lrImported || rrImported ||
        spareImported || props.importedDtc.length > 0 || props.importedCampaign.length > 0 ||
        props.importedRecommended.length > 0) {
        let importedLit: ReactElement | null = null;
        if (lfImported || rfImported || lrImported || rrImported || spareImported || oilImported || props.importedDtc.length > 0 ||
            props.importedCampaign.length > 0 || props.importedRecommended.length > 0) {
            importedLit =
                <div className={css.statusEntry}>
                    <div className={css.asterisk}>*</div>
                    <div className={css.statusLit}>{strings.ImportActionSelected}</div>
                </div>;
        }
        statusBottom2 =
            <div>
                <hr className={css.statusHr}></hr>
                <div className={css.statusBottom2}>
                    <span className={css.statusBlockBuild}>
                        {cvSettings}
                        {cvLog}
                        {mfgInquiry}
                        {buildData}
                    </span>
                    {importedLit}
                </div>
            </div>;
    }

    let printIcon: ReactElement | null = null;
    let restoreIcon: ReactElement | null = null;
    let errorMessage: ReactElement | null = null;
    if (!props.connectedVehicle.statusCode && (props.connectedVehicle.invokeError !== '1000')) {
        printIcon = <IconPrint className={css.lastIcon} onClick={() => printCV()} />;
        restoreIcon =
            <IconRestore
                className={css.firstIcon}
                onClick={() => invokeCV(props.connectedVehicle.tlmId ? props.connectedVehicle.tlmId : useTlmId)}
            />;
    } else {
        restoreIcon =
            <IconRestore
                className={css.lastIcon}
                onClick={() => invokeCV(props.connectedVehicle.tlmId ? props.connectedVehicle.tlmId : useTlmId)}
            />;
        if (props.connectedVehicle.invokeError === '1000') {
            errorMessage = <p className={css.error}>{strings.RefreshError}</p>;
        } else {
            errorMessage = <p className={css.error}>{strings.AnErrorOccurred + props.connectedVehicle.statusCode}</p>;
        }
    }

    let communications: ReactElement[] | null = null;
    let vehWarnUpdateTstamp: ReactElement | null = null;
    if (props.connectedVehicle.comm && (props.connectedVehicle.comm.length > 0)) {
        if (props.connectedVehicle.comm[0].vehWarnUpdDate && props.connectedVehicle.comm[0].vehWarnUpdTime) {
            vehWarnUpdateTstamp =
                <div className={css.commTstampLit}>{strings.DataAsOf + ' ' +
                    props.connectedVehicle.comm[0].vehWarnUpdDate + ' ' +
                    props.connectedVehicle.comm[0].vehWarnUpdTime}
                </div>;
        }
        const indexedComms: COMM[] = [];
        const vehComms = [...props.connectedVehicle.comm];
        let sortedComms: COMM[] = [];
        if ((sortIconCommColumn === 'none') || (sortIconCommColumn === 'date') || (sortIconCommColumn === 'time')) {
            sortedComms = vehComms.sort((a, b) => (b.warnTstamp > a.warnTstamp ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (a.warnTstamp > b.warnTstamp ? 1 : -1));
            }
        }
        if (sortIconCommColumn === 'type') {
            sortedComms = vehComms.sort((a, b) => (a.warnType > b.warnType ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (b.warnType > a.warnType ? 1 : -1));
            }
        }
        if (sortIconCommColumn === 'code') {
            sortedComms = vehComms.sort((a, b) => (a.featureCode > b.featureCode ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (b.featureCode > a.featureCode ? 1 : -1));
            }
        }
        if (sortIconCommColumn === 'desc') {
            sortedComms = vehComms.sort((a, b) => (a.warnManual > b.warnManual ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (b.warnManual > a.warnManual ? 1 : -1));
            }
        }
        if (sortIconCommColumn === 'urgency') {
            sortedComms = vehComms.sort((a, b) => (a.featureUrg > b.featureUrg ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (b.featureUrg > a.featureUrg ? 1 : -1));
            }
        }
        if (sortIconCommColumn === 'condition') {
            sortedComms = vehComms.sort((a, b) => (a.warnFlag > b.warnFlag ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (b.warnFlag > a.warnFlag ? 1 : -1));
            }
        }
        if (sortIconCommColumn === 'odometer') {
            sortedComms = vehComms.sort((a, b) => (a.warnMile > b.warnMile ? 1 : -1));
            if (commSortReversed) {
                sortedComms = vehComms.sort((a, b) => (b.warnMile > a.warnMile ? 1 : -1));
            }
        }
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        let lastMonth = currentDate.getMonth();
        let lastYear = currentYear;
        if (lastMonth === 0) {
            lastMonth = 12;
            lastYear = currentYear - 1;
        }
        let lastMonth1 = lastMonth - 1;
        let lastYear1 = lastYear;
        if (lastMonth1 === 0) {
            lastMonth1 = 12;
            lastYear1 = currentYear - 1;
        }
        let lastMonth2 = lastMonth1 - 1;
        let lastYear2 = lastYear1;
        if (lastMonth2 === 0) {
            lastMonth2 = 12;
            lastYear2 = currentYear - 1;
        }
        let lastMonth3 = lastMonth2 - 1;
        let lastYear3 = lastYear2;
        if (lastMonth3 === 0) {
            lastMonth3 = 12;
            lastYear3 = currentYear - 1;
        }
        let lastMonth4 = lastMonth3 - 1;
        let lastYear4 = lastYear3;
        if (lastMonth4 === 0) {
            lastMonth4 = 12;
            lastYear4 = currentYear - 1;
        }
        let lastMonth5 = lastMonth4 - 1;
        let lastYear5 = lastYear4;
        if (lastMonth5 === 0) {
            lastMonth5 = 12;
            lastYear5 = currentYear - 1;
        }
        let lastMonth6 = lastMonth5 - 1;
        let lastYear6 = lastYear5;
        if (lastMonth6 === 0) {
            lastMonth6 = 12;
            lastYear6 = currentYear - 1;
        }
        let lastMonth7 = lastMonth6 - 1;
        let lastYear7 = lastYear6;
        if (lastMonth7 === 0) {
            lastMonth7 = 12;
            lastYear7 = currentYear - 1;
        }
        let lastMonth8 = lastMonth7 - 1;
        let lastYear8 = lastYear7;
        if (lastMonth8 === 0) {
            lastMonth8 = 12;
            lastYear8 = currentYear - 1;
        }
        let lastMonth9 = lastMonth8 - 1;
        let lastYear9 = lastYear8;
        if (lastMonth9 === 0) {
            lastMonth9 = 12;
            lastYear9 = currentYear - 1;
        }
        let lastMonth10 = lastMonth9 - 1;
        let lastYear10 = lastYear9;
        if (lastMonth10 === 0) {
            lastMonth10 = 12;
            lastYear10 = currentYear - 1;
        }
        let lastMonth11 = lastMonth10 - 1;
        let lastYear11 = lastYear10;
        if (lastMonth11 === 0) {
            lastMonth11 = 12;
            lastYear11 = currentYear - 1;
        }
        let row: number = 0;
        sortedComms.forEach((comm) => {
            let keep: Boolean = true;
            const commYear: Number = comm.warnYear;
            const commMonth: Number = comm.warnMonth;
            if ((dateFilter === 'current') && ((commMonth !== currentMonth) || (commYear !== currentYear))) {
                keep = false;
            }
            if ((dateFilter === 'last') && ((commMonth !== lastMonth) || (commYear !== currentYear))) {
                keep = false;
            }
            if ((dateFilter === 'last6') && (((commMonth !== lastMonth) || (commYear !== lastYear)) &&
                ((commMonth !== lastMonth1) || (commYear !== lastYear1)) &&
                ((commMonth !== lastMonth2) || (commYear !== lastYear2)) &&
                ((commMonth !== lastMonth3) || (commYear !== lastYear3)) &&
                ((commMonth !== lastMonth4) || (commYear !== lastYear4)) &&
                ((commMonth !== lastMonth5) || (commYear !== lastYear5)) &&
                ((commMonth !== currentMonth) || (commYear !== currentYear)))) {
                keep = false;
            }
            if ((dateFilter === 'year') && (((commMonth !== lastMonth) || (commYear !== lastYear)) &&
                ((commMonth !== lastMonth1) || (commYear !== lastYear1)) &&
                ((commMonth !== lastMonth2) || (commYear !== lastYear2)) &&
                ((commMonth !== lastMonth3) || (commYear !== lastYear3)) &&
                ((commMonth !== lastMonth4) || (commYear !== lastYear4)) &&
                ((commMonth !== lastMonth5) || (commYear !== lastYear5)) &&
                ((commMonth !== lastMonth6) || (commYear !== lastYear6)) &&
                ((commMonth !== lastMonth7) || (commYear !== lastYear7)) &&
                ((commMonth !== lastMonth8) || (commYear !== lastYear8)) &&
                ((commMonth !== lastMonth9) || (commYear !== lastYear9)) &&
                ((commMonth !== lastMonth10) || (commYear !== lastYear10)) &&
                ((commMonth !== lastMonth11) || (commYear !== lastYear11)) &&
                ((commMonth !== currentMonth) || (commYear !== currentYear)))) {
                keep = false;
            }
            if (keep) {
                row = row + 1;
                indexedComms.push(
                    {
                        featureType: comm.featureType,
                        featureConf: comm.featureConf,
                        featureShow: comm.featureShow,
                        featureUrg: comm.featureUrg,
                        featureDate: comm.featureDate,
                        featureTime: comm.featureTime,
                        featureTstamp: comm.featureTstamp,
                        featureDesc: comm.featureDesc,
                        featureCode: comm.featureCode,
                        vehWarnUpdDate: comm.vehWarnUpdDate,
                        vehWarnUpdTime: comm.vehWarnUpdTime,
                        vehWarnUpdTstamp: comm.vehWarnUpdTstamp,
                        warnManual: comm.warnManual,
                        warnFlag: comm.warnFlag,
                        warnMileUnit: comm.warnMileUnit,
                        warnMile: comm.warnMile,
                        warnDate: comm.warnDate,
                        warnTime: comm.warnTime,
                        warnTstamp: comm.warnTstamp,
                        warnYear: comm.warnYear,
                        warnMonth: comm.warnMonth,
                        warnIcon: comm.warnIcon,
                        warnType: comm.warnType,
                        index: comm.index,
                        row: row,
                    },
                );
            }
        });
        communications = indexedComms.map((comm) => <CommunicationsPanel
            key={comm.index}
            index={comm.index}
            lastComm={props.connectedVehicle.comm.length - 1}
            row={comm.row}
        />);
    }

    let commIcon: ReactElement | null = null;
    let commFields: ReactElement | null = null;
    if (commOpen) {
        commIcon = <IconDropDownReverse id='commIcon' className={css.commIcon} onClick={() => toggleComm()} />;
        let commDateSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'date') {
            commDateSortIcon =
                <IconSortAscending id='commDateSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commDateSortIcon =
                    <IconSortDescending id='commDateSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commTimeSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'time') {
            commTimeSortIcon =
                <IconSortAscending id='commTimeSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commTimeSortIcon =
                    <IconSortDescending id='commTimeSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commTypeSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'type') {
            commTypeSortIcon =
                <IconSortAscending id='commTypeSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commTypeSortIcon =
                    <IconSortDescending id='commTypeSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commCodeSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'code') {
            commCodeSortIcon =
                <IconSortAscending id='commCodeSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commCodeSortIcon =
                    <IconSortDescending id='commCodeSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commDescSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'desc') {
            commDescSortIcon =
                <IconSortAscending id='commDescSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commDescSortIcon =
                    <IconSortDescending id='commDescSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commUrgencySortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'urgency') {
            commUrgencySortIcon =
                <IconSortAscending id='commUrgencySortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commUrgencySortIcon =
                    <IconSortDescending id='commUrgencySortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commConditionSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'condition') {
            commConditionSortIcon =
                <IconSortAscending id='commCondSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commConditionSortIcon =
                    <IconSortDescending id='commCondSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        let commOdometerSortIcon: ReactElement | null = null;
        if (sortIconCommColumn === 'odometer') {
            commOdometerSortIcon =
                <IconSortAscending id='commOdometerSortIcon' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            if (commSortReversed) {
                commOdometerSortIcon =
                    <IconSortDescending id='commOdometerSortIcon2' className={css.commSortIcon} onClick={() => reverseCommSort()}/>;
            }
        }
        commFields =
        <div>
            <div className={css.filterRow}>
                <div className={css.dateFilter}>
                    <SelectList
                        id='dateFilter'
                        value='current'
                        size='rg'
                        onChange={applyDateFilter}
                        dropDownList={commDates}
                        variant='roundedBorder'
                        disableUnderline={true}
                    />
                </div>
                {vehWarnUpdateTstamp}
            </div>
            <hr className={css.commHr}></hr>
            <div className={css.commRow}>
                <div className={css.commDateArea}>
                    <div id='commDateLit' className={css.commDateLit} onClick={() => moveFocusToComm('date')}>
                        {strings.Date}
                    </div>
                    {commDateSortIcon}
                </div>
                <div className={css.commTimeArea}>
                    <div id='commTimeLit' className={css.commTimeLit} onClick={() => moveFocusToComm('time')}>
                        {strings.CommTime}
                    </div>
                    {commTimeSortIcon}
                </div>
                <div className={css.commTypeArea}>
                    <div id='commTypeLit' className={css.commTypeLit} onClick={() => moveFocusToComm('type')}>
                        {strings.CommunicationType}
                    </div>
                    {commTypeSortIcon}
                </div>
                <div className={css.commCodeArea}>
                    <div id='commCodeLit' className={css.commCodeLit} onClick={() => moveFocusToComm('code')}>
                        <div>{strings.Code}/</div>
                        <div>{strings.Feature}</div>
                    </div>
                    {commCodeSortIcon}
                </div>
                <div className={css.commDescArea}>
                    <div id='commDescLit' className={css.commDescLit} onClick={() => moveFocusToComm('desc')}>
                        {strings.Description}
                    </div>
                    {commDescSortIcon}
                </div>
                <div className={css.commUrgencyArea}>
                    <div
                        id='commUrgencyLit'
                        className={css.commUrgencyLit}
                        onClick={() => moveFocusToComm('urgency')}>
                        <div>{strings.Urgency}/</div>
                        <div>{strings.Confidence}</div>
                    </div>
                    {commUrgencySortIcon}
                </div>
                <div className={css.commConditionArea}>
                    <div id='commConditionLit' className={css.commConditionLit} onClick={() => moveFocusToComm('condition')}>
                        {strings.Condition}
                    </div>
                    {commConditionSortIcon}
                </div>
                <div className={css.commOdometerArea}>
                    <div id='commOdometerLit' className={css.commOdometerLit} onClick={() => moveFocusToComm('odometer')}>
                        {strings.Odometer}
                    </div>
                    {commOdometerSortIcon}
                </div>
            </div>
            {communications}
        </div>;
    } else {
        commIcon = <IconDropDown id='commIcon2' className={css.commIcon} onClick={() => toggleComm()} />;
    }

    let vehComm: ReactElement | null = null;
    if (props.connectedVehicle.comm && (props.connectedVehicle.comm.length > 0)) {
        vehComm =
            <div>
                <span id='vehComm' className={css.vehComm} onClick={() => toggleComm()}>
                    <div className={css.statusText}>{strings.VehCommunications}</div>
                    {commIcon}
                </span>
                {commFields}
            </div>;
    }

    let baseScreen: ReactElement | null = null;
    if (props.connectedVehicle.tlmId || (props.connectedVehicle.invokeError === '1000')) {
        baseScreen =
            <div className={css.baseScreen}>
                <span className={css.header}>
                    <p className={css.headerText}>{vehDesc}</p>
                    {printIcon}
                    {restoreIcon}
                </span>
                <div className={css.statusBackground}>
                    <span className={css.statusTop}>
                        <p className={css.statusText}>{strings.ConnectedVehicleStatus}</p>
                    </span>
                    <hr className={css.statusHr}></hr>
                    {errorMessage}
                    <div className={css.statusBottom}>
                        {vehicleInfo}
                        {privacy}
                        {lastDataRefresh}
                        {telemetry}
                    </div>
                    {statusBottom2}
                </div>
                <ScrollBar scrollVertical>
                    <div className={css.scrollArea}>
                        {vehStatusArea}
                        {vehMaint}
                        {vehComm}
                    </div>
                </ScrollBar>
                <Dialog
                    id='VehSelMsg'
                    cssClasses={{
                        content: css.content,
                        paper: css.paper,
                        header: css.LightBoxHeader,
                    }}
                    isOpen={msgOpenFlag}
                    anchorOrigin={{
                        vertical: 'top',
                    }}
                    header={''}
                    hideSave={true}
                    hideCancel={true}
                    disableUpperCase={true}
                    onCancel={CloseMsgBox}
                    onBackDropClick={CloseMsgBox}
                    width='full'
                >
                    <div className={css.headerbox}>
                        {''}
                        <div className={css.headerIcon}>
                            <IconRemove id='closeBtn' onClick={CloseMsgBox}/>
                        </div>
                    </div>
                    <div>{msgBoxMsg}</div>
                </Dialog>
            </div>;
    }

    return (
        <div>
            {baseScreen}
            {loadingProgress}
        </div>
    );
};

export default ConnectedVehicle;